var fn = function( obj ){
var __t,__p='';
__p+='#version 300 es\n\nprecision highp float;\n\nin vec2 aPosition;\nin vec2 aTexCoord;\n\nout vec2 vTexCoord0;\n\nvoid main( void ){\n  gl_Position = vec4( aPosition, 0.0, 1.0 );\n  vTexCoord0 = aTexCoord;\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
